/* Papparazo: shoe grid for Kaching's "Choose another design".
   Every colour is its own tile and the size is picked right under it.
   Kaching's own list stays open but hidden; picking a tile drives it (colour, size, Choose),
   so Kaching still prices the bundle and applies the discount. */
(function () {
  if (window.__pzPicker) return;
  // Language (Sal, Oct 23): Arabic labels and Arabic store data when the visitor is on /ar.
  var AR = (document.documentElement.lang || '').indexOf('ar') === 0;
  var L = function (en, ar) { return AR ? ar : en; };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  window.__pzPicker = true;

  var CSS = [
    '.pzp-on .kaching-bundles__choose-product-modal{opacity:0!important;pointer-events:none!important}',
    '.pzp-lock,.pzp-lock body{overflow:hidden!important}',
    '.pzp-lock body{position:fixed!important;left:0;right:0;width:100%}',
    '.pzp{position:fixed;inset:0;z-index:2147483600;background:#fff;color:#111;display:flex;flex-direction:column;font-family:inherit;-webkit-text-size-adjust:100%}',
    '.pzp__in{width:100%;max-width:920px;margin:0 auto;box-sizing:border-box}',
    '.pzp__head{border-bottom:1px solid #eee}',
    '.pzp__head .pzp__in{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 16px}',
    '.pzp__head b{display:block;font-size:16px;font-weight:800;letter-spacing:.02em}',
    '.pzp__head small{display:block;font-size:11px;color:#777;font-weight:500;margin-top:2px}',
    '.pzp__x{flex:none;width:36px;height:36px;border:0;border-radius:50%;background:#f2f2f2;color:#111;font-size:22px;line-height:36px;padding:0;cursor:pointer}',
    '.pzp__tabs{border-bottom:1px solid #eee}',
    '.pzp__tabs .pzp__in{display:flex;gap:8px;padding:10px 16px;overflow-x:auto;scrollbar-width:none}',
    '.pzp__tabs .pzp__in::-webkit-scrollbar{display:none}',
    '.pzp__tab{flex:none;border:1.5px solid #ddd;background:#fff;color:#111;border-radius:999px;padding:7px 14px;font-size:12px;font-weight:700;cursor:pointer}',
    '.pzp__tab.on{background:#111;border-color:#111;color:#fff}',
    '.pzp__body{flex:1;min-height:0;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}',
    '.pzp__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px 10px;padding:14px 16px 32px}',
    '@media (min-width:700px){.pzp__grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:20px 14px}}',
    '.pzp__t{min-width:0;display:flex;flex-direction:column}',
    '.pzp__t[hidden]{display:none}',
    '.pzp__img{display:block;width:100%;aspect-ratio:1/1;border:1.5px solid #e6e6e6;border-radius:10px;overflow:hidden;background:#fff;padding:0;cursor:pointer}',
    '.pzp__img img{display:block;width:100%;height:100%;object-fit:contain}',
    '.pzp__t.on .pzp__img{border:2px solid #111}',
    '.pzp__n{font-size:11px;font-weight:700;line-height:1.25;margin-top:6px;min-height:2.5em;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
    '.pzp__c{font-size:10px;color:#777;text-transform:uppercase;letter-spacing:.03em;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.pzp__s{position:relative;margin-top:6px}',
    /* 16px keeps iPhone from zooming in when the size list opens */
    '.pzp__s select{display:block;width:100%;box-sizing:border-box;-webkit-appearance:none;appearance:none;border:1.5px solid #111;border-radius:8px;background:#fff;color:#111;font:700 16px/1.2 inherit;padding:6px 20px 6px 8px;margin:0}',
    '.pzp__t.on .pzp__s select{background:#111;color:#fff}',
    '.pzp__s:after{content:"";position:absolute;right:8px;top:50%;margin-top:-2px;border:4px solid transparent;border-top-color:currentColor;pointer-events:none}',
    '.pzp__t.on .pzp__s:after{color:#fff}',
    '.pzp__empty{grid-column:1/-1;text-align:center;color:#777;font-size:13px;padding:40px 0}',
    /* When the bundle box shows, the theme's colour picker is hidden (the box picks colour). The theme's SIZE picker stays
       visible above the box (Sal, Oct 27) and feeds every pair below; any other default-style option is hidden. */
    'form.product-form:has(kaching-bundle[data-initialized="true"]) .product-options__swatch,form.product-form:has(kaching-bundle[data-initialized="true"]) .product-options__default:not(:has(input[data-option*="size" i],input[data-option*="مقاس"])){display:none!important}',
    /* Sal (Oct 23): also drop the "Extra applied in cart" tag, the In Stock line and the "Bundle & Save" heading on these pages. */
    'form.product-form:has(kaching-bundle[data-initialized="true"]) .product-custom-liquid:has(.pzo-pptag),form.product-form:has(kaching-bundle[data-initialized="true"]) .size-stock-row{display:none!important}',
    'kaching-bundle .kaching-bundles__block-title{display:none!important}',
    /* Bigger colour squares (36px -> 45px, Sal Oct 23). Size box moves up next to the shoe name so a pair still fits one row on a phone. */
    /* Kaching nests its "All deals" CSS inside kaching-bundles-block[deal-block-id] {...}, which adds specificity;
       the same prefix plus doubled classes lets these rules win. */
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__swatch-buttons.kaching-bundles__swatch-buttons .kaching-bundles__swatch{width:45px!important;height:45px!important}',
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__swatch-buttons.kaching-bundles__swatch-buttons{gap:5px!important}',
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__collection-product__title.kaching-bundles__collection-product__title{line-height:34px!important;max-width:calc(100% - 118px)!important}',
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__bar-variant-option.kaching-bundles__bar-variant-option:not(:has(.kaching-bundles__swatch-buttons)){position:absolute!important;top:6px;right:0;flex-direction:row!important;align-items:center!important;gap:6px!important;margin:0!important}',
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__bar-variant-option:not(:has(.kaching-bundles__swatch-buttons)) .kaching-bundles__bar-variant-select.kaching-bundles__bar-variant-select{padding:7px 22px 7px 9px!important}',
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__collection-product__remove-button.kaching-bundles__collection-product__remove-button{right:0!important;bottom:23px!important;width:47px!important;height:47px!important}',
    'kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product:has(.kaching-bundles__collection-product__remove-button) .kaching-bundles__bar-variant-option.kaching-bundles__bar-variant-option:has(.kaching-bundles__swatch-buttons){padding-right:54px!important}',
    // Arabic (right-to-left): mirror the size box, the + square and its gap.
    'html[dir="rtl"] kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__bar-variant-option.kaching-bundles__bar-variant-option:not(:has(.kaching-bundles__swatch-buttons)){right:auto!important;left:0!important}',
    'html[dir="rtl"] kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__collection-product__remove-button.kaching-bundles__collection-product__remove-button{right:auto!important;left:0!important}',
    'html[dir="rtl"] kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product:has(.kaching-bundles__collection-product__remove-button) .kaching-bundles__bar-variant-option.kaching-bundles__bar-variant-option:has(.kaching-bundles__swatch-buttons){padding-right:0!important;padding-left:54px!important}',
    'html[dir="rtl"] .pzp__s:after{right:auto;left:8px}',
    'html[lang^="ar"] kaching-bundles-block[deal-block-id] .kaching-bundles__collection-product.kaching-bundles__collection-product .kaching-bundles__collection-product__remove-button.kaching-bundles__collection-product__remove-button:after{content:"تصميم\\a آخر"!important}'
  ].join('\n');
  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var text = function (el) { return el ? el.textContent.trim() : ''; };
  var fire = function (sel) {
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  };
  // option names come translated on /ar (المقاس / اللون), so match both languages
  var sizeSelect = function (row) {
    return [].slice.call(row.querySelectorAll('select')).filter(function (s) { return /size|مقاس/i.test(s.dataset.name || ''); })[0];
  };
  var colourSelect = function (row) {
    return [].slice.call(row.querySelectorAll('select')).filter(function (s) { return /colou?r|لون/i.test(s.dataset.name || ''); })[0];
  };
  var bigger = function (src) {
    if (!src) return '';
    if (/_\d+x\d*\./.test(src)) return src.replace(/_\d+x\d*\./, '_400x400.');
    try {
      var u = new URL(src, location.href);
      u.searchParams.delete('height');
      u.searchParams.set('width', '400');
      return u.toString();
    } catch (e) { return src; }
  };
  // Kaching's swatch photo. The computed background is an absolute URL in every browser;
  // reading the raw style text came back empty on iPhone Safari (blank src = "?" icons).
  var swatchSrc = function (sw) {
    if (!sw) return '';
    var v = '';
    try { v = getComputedStyle(sw).backgroundImage; } catch (e) {}
    if (!v || v === 'none') { try { v = getComputedStyle(sw).getPropertyValue('--kaching-swatch-image-url'); } catch (e) {} }
    if (!v || v === 'none') v = sw.getAttribute('style') || '';
    var m = v.match(/url\(\s*\\?["']?([^"')\\]+)/);
    return m ? m[1] : '';
  };
  var jsonImage = function (p, colour) {
    if (!p) return '';
    var ci = p.options.findIndex(function (o) { return /colou?r|لون/i.test(o.name || o); });
    var v = p.variants.filter(function (x) { return (!colour || x.options[ci] === colour) && x.featured_image; })[0];
    return v ? v.featured_image.src : (p.featured_image || '');
  };
  var handleOf = function (row) {
    var a = row.querySelector('a[href*="/products/"]');
    if (!a) return '';
    try { return decodeURIComponent(new URL(a.href).pathname.split('/products/')[1].split('/')[0]); } catch (e) { return ''; }
  };

  // Formal / Boots tabs come from the store's own collections; everything else is a sneaker.
  var cats = null;
  var loadCats = function () {
    if (cats) return Promise.resolve(cats);
    var c = {};
    return Promise.all(['formal', 'boots'].map(function (h) {
      return fetch(ROOT + 'collections/' + h + '/products.json?limit=250').then(function (r) { return r.json(); })
        .then(function (j) { j.products.forEach(function (p) { if (!c[p.handle]) c[p.handle] = h; }); })
        .catch(function () {});
    })).then(function () { cats = c; return c; });
  };

  // Shoes whose colour is a drop-down (option named "Color"/"color") have no swatch photos in Kaching's list.
  var jsonCache = {};
  var productJson = function (handle) {
    if (!jsonCache[handle]) {
      jsonCache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    return jsonCache[handle];
  };

  var state = { overlay: null, modal: null, prev: null, done: false, scrollY: 0 };

  var tilesFor = function (row) {
    var title = text(row.querySelector('.kaching-bundles__choose-product__product-title'));
    var handle = handleOf(row);
    var sizes = [];
    var ss = sizeSelect(row);
    if (ss) sizes = [].slice.call(ss.options).map(function (o) { return o.value; });
    var swatches = [].slice.call(row.querySelectorAll('.kaching-bundles__swatch-buttons__button'));
    var rowImg = (row.querySelector('img.kaching-bundles__choose-product__product-image') || {}).src || '';
    if (swatches.length) {
      return Promise.resolve(swatches.map(function (b) {
        var raw = swatchSrc(b.querySelector('.kaching-bundles__swatch'));
        return { row: row, title: title, handle: handle, colour: b.dataset.value, raw: raw, img: bigger(raw), rowImg: rowImg, sizes: sizes };
      }));
    }
    var cs = colourSelect(row);
    if (!cs) return Promise.resolve([{ row: row, title: title, handle: handle, colour: '', raw: rowImg, img: bigger(rowImg), rowImg: rowImg, sizes: sizes }]);
    var colours = [].slice.call(cs.options).map(function (o) { return o.value; });
    return productJson(handle).then(function (p) {
      return colours.map(function (col) {
        var raw = jsonImage(p, col) || rowImg;
        return { row: row, title: title, handle: handle, colour: col, raw: raw, img: bigger(raw), rowImg: rowImg, sizes: sizes };
      });
    });
  };

  var commit = async function (row, colour, size) {
    if (colour) {
      var b = [].slice.call(row.querySelectorAll('.kaching-bundles__swatch-buttons__button')).filter(function (x) { return x.dataset.value === colour; })[0];
      if (b) b.click();
      else { var cs = colourSelect(row); if (cs) { cs.value = colour; fire(cs); } }
      await wait(150);
    }
    var ss = sizeSelect(row);
    if (ss && size) { ss.value = size; fire(ss); await wait(150); }
    var btn = row.querySelector('.kaching-bundles__choose-product__product-button');
    if (btn) btn.click();
  };

  var unlock = function () {
    document.documentElement.classList.remove('pzp-lock', 'pzp-on');
    document.body.style.top = '';
    window.scrollTo(0, state.scrollY);
  };

  var close = async function () {
    if (!state.overlay) return;
    state.overlay.remove();
    state.overlay = null;
    unlock();
    var modal = state.modal;
    state.modal = null;
    if (!modal || !document.contains(modal)) return;
    // Closed without picking: put back the shoe that was in this pair.
    var prev = state.prev;
    var row = prev && [].slice.call(modal.querySelectorAll('.kaching-bundles__choose-product__product'))
      .filter(function (r) { return text(r.querySelector('.kaching-bundles__choose-product__product-title')) === prev.title; })[0];
    if (row) await commit(row, prev.colour, prev.size);
    else { var x = modal.querySelector('.kaching-bundles__choose-product__close'); if (x) x.click(); }
  };

  var open = async function (modal) {
    state.modal = modal;
    state.scrollY = window.scrollY;
    document.body.style.top = -state.scrollY + 'px';
    document.documentElement.classList.add('pzp-on', 'pzp-lock');

    var ov = document.createElement('div');
    ov.className = 'pzp';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.innerHTML =
      '<div class="pzp__head"><div class="pzp__in"><div><b>' + L('Choose another design', 'اختر تصميماً آخر') + '</b><small>' + L('Same bundle price', 'بنفس سعر العرض') + '</small></div>' +
      '<button type="button" class="pzp__x" aria-label="' + L('Close', 'إغلاق') + '">&times;</button></div></div>' +
      '<div class="pzp__tabs"><div class="pzp__in">' +
      '<button type="button" class="pzp__tab on" data-c="all">' + L('All', 'الكل') + '</button>' +
      '<button type="button" class="pzp__tab" data-c="sneakers">' + L('Sneakers', 'سنيكرز') + '</button>' +
      '<button type="button" class="pzp__tab" data-c="formal">' + L('Formal', 'رسمي') + '</button>' +
      '<button type="button" class="pzp__tab" data-c="boots">' + L('Boots', 'بوت') + '</button></div></div>' +
      '<div class="pzp__body"><div class="pzp__in"><div class="pzp__grid"><div class="pzp__empty">' + L('Loading…', 'جارٍ التحميل…') + '</div></div></div></div>';
    document.body.appendChild(ov);
    state.overlay = ov;
    ov.querySelector('.pzp__x').addEventListener('click', close);

    var rows = [].slice.call(modal.querySelectorAll('.kaching-bundles__choose-product__product'));
    var lists = await Promise.all(rows.map(tilesFor));
    var c = await loadCats();
    if (state.overlay !== ov) return;
    var grid = ov.querySelector('.pzp__grid');
    grid.innerHTML = '';
    lists.forEach(function (tiles) {
      tiles.forEach(function (t) {
        var el = document.createElement('div');
        el.className = 'pzp__t';
        el.dataset.cat = c[t.handle] || 'sneakers';
        el.innerHTML =
          '<button type="button" class="pzp__img"><img loading="lazy" alt=""></button>' +
          '<div class="pzp__n"></div><div class="pzp__c"></div>' +
          '<label class="pzp__s"><select aria-label="' + L('Size', 'المقاس') + '"><option value="" selected disabled>' + L('Size', 'المقاس') + '</option></select></label>';
        var img = el.querySelector('img');
        // Fallbacks: the original (not resized) link, then the photo from the shoe's own store data.
        img.onerror = function () {
          if (img.dataset.f === '2') return;
          if (!img.dataset.f && t.raw && img.src !== t.raw) { img.dataset.f = '1'; img.src = t.raw; return; }
          img.dataset.f = '2';
          productJson(t.handle).then(function (p) {
            var s = jsonImage(p, t.colour) || t.rowImg;
            if (s) img.src = bigger(s);
          });
        };
        if (t.img) img.src = t.img;
        else img.onerror();
        el.querySelector('.pzp__n').textContent = t.title;
        el.querySelector('.pzp__c').textContent = t.colour;
        var sel = el.querySelector('select');
        t.sizes.forEach(function (s) { var o = document.createElement('option'); o.value = s; o.textContent = 'EU ' + s; sel.appendChild(o); });
        el.querySelector('.pzp__img').addEventListener('click', function () {
          [].forEach.call(grid.querySelectorAll('.pzp__t.on'), function (x) { x.classList.remove('on'); });
          el.classList.add('on');
          try { sel.showPicker(); } catch (e) { sel.focus(); }
        });
        sel.addEventListener('change', async function () {
          if (!sel.value) return;
          el.classList.add('on');
          var row = t.row, size = sel.value, colour = t.colour;
          state.modal = null; // picked: don't restore the old shoe
          ov.remove();
          state.overlay = null;
          unlock();
          await commit(row, colour, size);
        });
        grid.appendChild(el);
      });
    });

    [].forEach.call(ov.querySelectorAll('.pzp__tab'), function (b) {
      b.addEventListener('click', function () {
        [].forEach.call(ov.querySelectorAll('.pzp__tab'), function (x) { x.classList.toggle('on', x === b); });
        [].forEach.call(grid.querySelectorAll('.pzp__t'), function (t) { t.hidden = b.dataset.c !== 'all' && t.dataset.cat !== b.dataset.c; });
        ov.querySelector('.pzp__body').scrollTop = 0;
      });
    });
  };

  // "+ Other design" square: remember the shoe in that pair, then open the picker straight away (one tap).
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('.kaching-bundles__collection-product__remove-button');
    if (!rm) return;
    var slot = rm.closest('.kaching-bundles__collection-product');
    var list = slot && slot.parentElement;
    if (!slot || !list) return;
    var sel = slot.querySelector('.kaching-bundles__swatch-buttons__button--selected');
    var cs = colourSelect(slot), ss = sizeSelect(slot);
    state.prev = {
      title: text(slot.querySelector('.kaching-bundles__collection-product__title')),
      colour: sel ? sel.dataset.value : (cs ? cs.value : ''),
      size: ss ? ss.value : ''
    };
    var index = [].slice.call(list.children).indexOf(slot);
    setTimeout(function () {
      var again = list.children[index];
      var btn = again && again.querySelector('.kaching-bundles__collection-product__choose-product-button');
      if (btn) btn.click();
    }, 80);
  }, true);

  // A plain tap on "Choose another design" (empty pair): nothing to put back if they close.
  document.addEventListener('click', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('.kaching-bundles__collection-product__choose-product-button, .kaching-bundles__collection-product__choose-product-image')) state.prev = null;
  }, true);

  // The theme's colour/size are hidden while the box shows, so keep them matching pair #1 of the selected deal:
  // that switches the gallery photos the theme's own way and stops the theme ever disagreeing with the box.
  var syncTheme = function () {
    var bar = document.querySelector('kaching-bundle .kaching-bundles__bar--selected');
    var v = bar && bar.querySelector('.kaching-bundles__bar-variant');
    var form = v && v.closest('form.product-form');
    if (!form) return;
    var sw = v.querySelector('.kaching-bundles__swatch-buttons__button--selected');
    var cs = colourSelect(v), ss = sizeSelect(v);
    [[/colou?r|لون/i, sw ? sw.dataset.value : (cs ? cs.value : '')], [/size|مقاس/i, ss ? ss.value : '']].forEach(function (pair) {
      if (!pair[1]) return;
      var radio = [].slice.call(form.querySelectorAll('input.radio-input[data-option]')).filter(function (i) {
        return pair[0].test(i.dataset.option) && i.value === pair[1];
      })[0];
      if (radio && !radio.checked) radio.click();
    });
  };
  var syncTimer = null;
  var queueSync = function (e) {
    if (!e.target.closest || !e.target.closest('kaching-bundle')) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncTheme, 250);
  };
  document.addEventListener('click', queueSync, true);
  document.addEventListener('change', queueSync, true);

  // Theme size picker -> box. A size tapped above the box goes into every pair of the selected deal; pairs that show up
  // later (switching to 2 or 3 pairs, "+ Other design") get it too. A size changed inside the box for one pair is left
  // alone, and changing pair #1 there becomes the new size for pairs added after it.
  var chosenSize = '';
  var sizedBar = -1, sizedCount = 0;
  var isSizeRadio = function (el) {
    return el && el.matches && el.matches('input.radio-input[data-option]') && /size|مقاس/i.test(el.dataset.option || '');
  };
  var pairRows = function () {
    var bar = document.querySelector('kaching-bundle .kaching-bundles__bar--selected');
    if (!bar) return [];
    return [].slice.call(bar.querySelectorAll('.kaching-bundles__bar-variant, .kaching-bundles__collection-product')).filter(function (r) {
      return !(r.parentElement && r.parentElement.closest('.kaching-bundles__bar-variant, .kaching-bundles__collection-product')) && sizeSelect(r);
    });
  };
  var barIndex = function () {
    var bars = [].slice.call(document.querySelectorAll('kaching-bundle .kaching-bundles__bar'));
    return bars.indexOf(document.querySelector('kaching-bundle .kaching-bundles__bar--selected'));
  };
  var setSize = function (row) {
    var ss = sizeSelect(row);
    var ok = ss && [].some.call(ss.options, function (o) { return o.value === chosenSize && !o.disabled; });
    if (ok && ss.value !== chosenSize) { ss.value = chosenSize; fire(ss); }
  };
  var applySize = function (all) {
    if (!chosenSize) return;
    var rows = pairRows();
    var bi = barIndex();
    if (bi !== sizedBar) { sizedBar = bi; sizedCount = 0; }
    rows.forEach(function (row, i) { if (all || i >= sizedCount) setSize(row); });
    sizedCount = rows.length;
  };
  document.addEventListener('change', function (e) {
    if (!e.isTrusted || !e.target) return;
    if (isSizeRadio(e.target) && e.target.closest('form.product-form:has(kaching-bundle[data-initialized="true"])')) {
      chosenSize = e.target.value;
      applySize(true);
      return;
    }
    if (e.target.tagName === 'SELECT' && e.target.closest('kaching-bundle') && /size|مقاس/i.test(e.target.dataset.name || '')) {
      var rows = pairRows();
      if (rows[0] && sizeSelect(rows[0]) === e.target) chosenSize = e.target.value;
    }
  }, true);
  var sizeTick = false;
  new MutationObserver(function () {
    if (!chosenSize || sizeTick) return;
    sizeTick = true;
    requestAnimationFrame(function () { sizeTick = false; applySize(false); });
  }).observe(document.body, { childList: true, subtree: true });

  // Kaching opened its list: hide it and show the grid instead.
  new MutationObserver(function () {
    var m = document.querySelector('.kaching-bundles__choose-product-modal');
    if (m && !m.dataset.pzp) {
      m.dataset.pzp = '1';
      open(m);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
